import {
  FETCH_STORE_MANAGER,
  RESET_STORE_MANAGER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const storeManagerViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STORE_MANAGER:
      return { data: action.payload };
    case RESET_STORE_MANAGER:
      return initialState;
    default:
      return state;
  }
};

export default storeManagerViewReducer;
